import { Injectable } from '@angular/core';
import { ProjectAggregateStoreService } from './project-aggregate-store.service';
import { FilterStoreService } from 'src/app/hire-person-search/store/filter-store.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { ActivatedRoute } from '@angular/router';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';
import { ProjectAggregateRequest } from '../enums/projectAggregate';
import * as _ from 'underscore';
import { CallStage } from 'src/app/enums/CallStage';



@Injectable({
  providedIn: 'root',
})
export class ProjectAggregateService {

  constructor(private projectaggregatestore: ProjectAggregateStoreService, private filterStore: FilterStoreService, private localStorageService: LocalStorageService, private filterDataHandlerService: FilterDataHandlerService, private activatedRoute: ActivatedRoute) {}

  getProjectAggregateServices() {
    const request = this.projectaggregatestore.getProjectAggregateRequest();

    const filterData = this.filterStore.getFilters();

    // ── Apply core filters ─────────────────────────────────────────────
    const statusMap = this.getStatusMap(filterData);

    // ── Apply core filters ─────────────────────────────────────────────
    this.applyFilters(request, filterData, statusMap);

    // ── Profile highlights, position hierarchy ─────────────────────────
    request.profilehighlights = filterData.profilehighlights;
    request.positionhierarchies = filterData.positionhierarchy;

    // ── Profile highlights, position hierarchy ─────────────────────────
    request.profilehighlights = filterData.profilehighlights;
    request.positionhierarchies = filterData.positionhierarchy;


    // ── Locations (NO JD fallback, NO AI sourcing, NO SC checks) ──────
    if (filterData.locationSelectedList?.length) {
      request.locations = filterData.locationSelectedList
        .filter(l => l.isExcluded === false)
        .map(l => l.key);
    } else {
      request.locations = [this.localStorageService.getItem('defaultContinent')];
    }
    request.continentstobeincluded = filterData?.continentstobeincluded?.length ? filterData?.continentstobeincluded : [this.localStorageService.getItem('defaultContinent')];

    // ── Mandatory & Insights filters ───────────────────────────────────
    this.applyMandatoryFilters(request, filterData);
    //  this.applyInsightsFilters(request);

    // ── Redirect / listing page cleanup ───────────────────────────────






    // Flatten experience arrays
    request.maxexperience = filterData?.yearsofexperienceTo ? Number(filterData?.yearsofexperienceTo) : null;
    request.minexperience = filterData?.yearsofexperienceFrom ? Number(filterData?.yearsofexperienceFrom) : null;
    request.current_maxexperience = filterData?.currenttoyearsofexperience ? Number(filterData?.currenttoyearsofexperience) : null;
    request.current_minexperience = filterData?.currentfromyearsofexperience ? Number(filterData?.currentfromyearsofexperience) : null;

    // if (
    //   !(request?.maxexperience && request?.minexperience) &&
    //   (request?.maxexperience || request?.minexperience)
    // ) {
    //   if (!request?.maxexperience) request.maxexperience = 40;
    //   else if (!request?.minexperience) request.minexperience = 0;
    // }

    // if (
    //   !(request?.current_maxexperience && request?.current_minexperience) &&
    //   (request?.current_maxexperience || request?.current_minexperience)
    // ) {
    //   if (!request?.current_maxexperience) request.current_maxexperience = 40;
    //   else if (!request?.current_minexperience) request.current_minexperience = 0;
    // }
    return request;
  }

    private applyFilters(request: ProjectAggregateRequest, filterData: FilterParams, statusMap: { jobTitleStatus: string; companyStatus: string; industryStatus: string; yearsOfExperienceType: string; }) {



      request.booleanquery = this.getBooleanQuery(filterData);

      request.jobtitles = _.uniq(filterData?.jobTitleSelectedList?.filter(jobTitle => !jobTitle.isExcluded).map(j => (j.isSuggested && j.key.includes('.includedaisearch') ? j.key : !j.key.includes('.aisearch') && j.isSuggested ? `${j.key}.aisearch` : j.key)));
      request.excluded_jobtitles = this.getExcludeJobtitles(filterData);
      request.jobtitletype = statusMap.jobTitleStatus;

      request.excluded_locations = this.getExcludeLocations(filterData);

      request.pastjobtitles = filterData?.pastJobTitleSelectedList?.filter(l => !l.isExcluded).map(j => (j.isSuggested && !j.key.includes('.aisearch') ? `${j.key}.aisearch` : j.key));
      request.excluded_pastjobtitles = this.getExcludePastJobTitles(filterData);

      request.preferredskills = filterData?.skillsSelectedList?.filter(s => (!s.isMandatory && !s.isExcluded)).map(s => (s.isSuggested && s.key.includes('.includedaisearch') ? s.key : !s.key.includes('.aisearch') && s.isSuggested ? `${s.key}.aisearch` : s.key));

      request.companies = filterData?.companySelectedList?.filter(company => company.isExcluded == false).map(j => j.key);
      request.excluded_companies = this.getExcludeCompanies(filterData);
      request.companytype = statusMap.companyStatus;

      request.companysizes = this.getCompanySizes(filterData);

      request.profilehighlights = filterData.profilehighlights;

      request.industries = filterData?.industrySelectedList?.filter(industry => !industry.isExcluded).map(i => i.key);
      request.industrytype = statusMap.industryStatus;
      request.excluded_industries = this.getExcludeIndustries(filterData);
      request.functions = filterData?.functionSelectedList?.filter(l => !l.isExcluded).map(l => l.key);
      request.seniority = filterData?.seniority ? _.flatten(filterData?.seniority) : [];

      // Years of experience
      request.minexperience = this.getFromYrsOfExperience(filterData);
      request.maxexperience = this.getToYrsOfExperience(filterData);
      request.experiencetype = statusMap.yearsOfExperienceType;
      request.tograduationyear = this.getYearsOfGraduationKeys('tograduationyear', filterData);
      request.fromgraduationyear = this.getYearsOfGraduationKeys('fromgraduationyear', filterData);

      request.current_minexperience = this.getYrsInCurrentCompanyFrom(filterData);
      request.current_maxexperience = !!filterData.currenttoyearsofexperience ? Number(filterData.currenttoyearsofexperience) : null;

      // Gender
      request.genders = this.getGender(filterData);

      // Education
      request.educationaldegrees = filterData?.educationSelectedList?.map(e => e.key);

      // School
      request.schools = filterData?.schoolSelectedList?.map(s => s.key);

      // Education List
      request.schoollocation = filterData?.schoolLocationSelectedList?.filter(l => !l.isExcluded).map(l => l.key);

      // Exclude education location


      // Field Of Study
      request.educationalmajors = filterData?.fieldOfStudySelectedList?.map(fs => fs.key);


      request.fullnames = filterData.fullNameSelectedList?.length > 0 ? filterData.fullNameSelectedList.map(x => x.key) : [];

      request.distancefromselectedlocations = filterData?.distancefromselectedlocations ? filterData?.distancefromselectedlocations : 100;
      request.distancefromselectedlocationsmeasurementunit = filterData?.distancefromselectedlocationsmeasurementunit ? filterData?.distancefromselectedlocationsmeasurementunit : 'Kilometers';





      // if (!(request?.toyearsofexperience?.length && request?.fromyearsofexperience?.length) &&
      //   (request?.toyearsofexperience?.length || request?.fromyearsofexperience?.length)) {
      //   if (!request?.toyearsofexperience?.length) {
      //     request.toyearsofexperience = [40];
      //   } else if (!request?.fromyearsofexperience?.length) {
      //     request.fromyearsofexperience = [0];
      //   }
      // }

      // if (!(request?.currenttoyearsofexperience?.length && request?.currentfromyearsofexperience?.length) &&
      //   (request?.currenttoyearsofexperience?.length || request?.currentfromyearsofexperience?.length)) {
      //   if (!request?.currenttoyearsofexperience?.length) {
      //     request.currenttoyearsofexperience = [40];
      //   } else if (!request?.currentfromyearsofexperience?.length) {
      //     request.currentfromyearsofexperience = [0];
      //   }
      // }


      request.excluded_preferredskills = this.getExcludeSkills(filterData);
      request.excluded_functions = this.getExcludeFunctions(filterData)

    }


    private applyMandatoryFilters(request: ProjectAggregateRequest, filterData: FilterParams) {


      request.mandatoryskills = this.getMandatorySkills(filterData);
      request.excluded_mandatoryskills = this.getExcludeMandatorySkills(filterData);
    }



    getYearsOfGraduationKeys(key, filterData: FilterParams) {
      if (key == 'tograduationyear') {
        return filterData.tograduationyear;
      } else if (key == 'fromgraduationyear') {
        return filterData.fromgraduationyear;
      }
      return null
    }

    private getFromYrsOfExperience(filterData: FilterParams) {

      //It should be valid for Zero, Gives falsy value only in case of null
      if (typeof (filterData.yearsofexperienceFrom) == 'number')
        return filterData.yearsofexperienceFrom;

      return null;
    }

    private getToYrsOfExperience(filterData: FilterParams) {
      if (filterData.yearsofexperienceTo && typeof (filterData.yearsofexperienceTo) == 'number')
        return filterData.yearsofexperienceTo;

      return null;
    }

    private getYrsInCurrentCompanyFrom(filterData: FilterParams) {

      if (filterData.currentfromyearsofexperience) {
        return filterData.currentfromyearsofexperience;
      } else {
        return null;
      }
    }



      private getMandatorySkills(filterData: FilterParams) {
        let mandatorySkills = [];
        if (filterData.skillsSelectedList?.length) {
          mandatorySkills = filterData.skillsSelectedList?.filter(el => (!!el.isMandatory && !el.isExcluded)).map(el => el.isSuggested && !el.key.includes('.aisearch') ? `${el.key}.aisearch` : el.key);
        }

        return mandatorySkills;
      }




      private getGender(filterData: FilterParams) {
        return filterData?.gender ? [filterData.gender] : ['All'];
      }

      private getExcludeJobtitles(filterData: FilterParams) {
        let excludeJobTitles = filterData.jobTitleSelectedList?.length ?
          filterData.jobTitleSelectedList?.filter(j => !!j.isExcluded).map(j => j.isSuggested && !j.key.includes('.aisearch') ? `${j.key}.aisearch` : j.key) : [];

        return _.uniq(excludeJobTitles);
      }

      private getExcludeLocations(filterData: FilterParams) {
        let excludeLocations = filterData.locationSelectedList?.length ?
          filterData.locationSelectedList?.filter(j => !!j.isExcluded).map(j => j.key) : [];
        return _.uniq(excludeLocations);
      }

      // private getSelectedCompanies(extraInfo: ExtraInfo,redirectDataTI: FilterParams, redirectDataCI: FilterParams, filterData: FilterParams) {
      //   if(this.talentInsightsReqHandlerService.isCompanyInsightsTab)
      // }

      private getExcludeCompanies(filterData: FilterParams) {
        let excludeCompanies = filterData.companySelectedList?.length ?
          filterData.companySelectedList?.filter(j => !!j.isExcluded).map(j => j.key) : [];
        return _.uniq(excludeCompanies);
      }

      private getExcludeIndustries(filterData: FilterParams) {
        let excludeIndustries = filterData.industrySelectedList?.length ?
          filterData.industrySelectedList?.filter(j => !!j.isExcluded).map(j => j.key) : [];
        return _.uniq(excludeIndustries);
      }

      private getExcludSchoolLocation(filterData: FilterParams) {
        let excludeSchoolLocations = filterData.schoolLocationSelectedList?.length ?
          filterData.schoolLocationSelectedList?.filter(j => !!j.isExcluded).map(j => j.key) : [];
        return _.uniq(excludeSchoolLocations);
      }

      private getExcludeSkills(filterData: FilterParams) {
        let excludeSkills = filterData.skillsSelectedList?.length ?
          filterData.skillsSelectedList?.filter(s => (!!s.isExcluded && s.isMandatory == false)).map(s => s.isSuggested && !s.key.includes('.aisearch') ? `${s.key}.aisearch` : s.key) : [];

        return _.uniq(excludeSkills);
      }

      private getExcludeMandatorySkills(filterData: FilterParams) {
        let excludeSkills = filterData.skillsSelectedList?.length ?
          filterData.skillsSelectedList?.filter(s => (!!s.isExcluded && s.isMandatory == true)).map(s => s.isSuggested && !s.key.includes('.aisearch') ? `${s.key}.aisearch` : s.key) : [];

        return _.uniq(excludeSkills);
      }

      private getExcludeFunctions(filterData: FilterParams) {
        let excludeFunctions = filterData.functionSelectedList?.length ?
          filterData.functionSelectedList?.filter(j => !!j.isExcluded).map(j => j.key) : [];
        return _.uniq(excludeFunctions);
      }

      private getCompanySizes(filterData: FilterParams) {
        const companySizeFilterData = filterData.companysize ? _.flatten(filterData.companysize) : [];
        if (companySizeFilterData?.length) {
          return companySizeFilterData;
        }

        return [];
      }

      private getBooleanQuery(filterData: FilterParams) {
        // if ('talent-insights' === extraInfo.redirectSource && redirectDataTI?.keywordSelectedList?.length) {
        //   return redirectDataTI.keywordSelectedList.filter(Boolean).map(el => el.key);
        // }
        // if (this.filterDataHandlerService.isReportDetailsPage && filterData?.keywordSelectedList?.length) {
        //   return filterData.keywordSelectedList.filter(Boolean).map(el => el.key);
        // }
        return filterData.booleanquery ? filterData.booleanquery : "*";
      }

      private getExcludePastJobTitles(filterData: FilterParams) {
        let excludePastJobTitles = filterData?.pastJobTitleSelectedList?.length ?
          filterData.pastJobTitleSelectedList?.filter(j => !!j.isExcluded).map(j => j.isSuggested && !j.key.includes('.aisearch') ? `${j.key}.aisearch` : j.key) : [];
        return _.uniq(excludePastJobTitles);
      }

      // manadatoryApplicable(extraInfo: ExtraInfo) {
      //   return (
      //     extraInfo?.redirectSource == 'talent-insights' ||
      //     extraInfo?.redirectSource == 'company-insights'
      //   );
      // }

  private getStatusMap(filterData: FilterParams) {
    return {
      jobTitleStatus: filterData.jobTitleStatus ? filterData.jobTitleStatus == 'Current or Past' ? 'All': filterData.jobTitleStatus : CallStage.CURRENT.toString(),
      companyStatus: filterData.companyStatus ? filterData.companyStatus == 'Current or Past' ? 'All' : filterData.companyStatus : CallStage.CURRENT.toString(),
      industryStatus: filterData.industryStatus ? filterData.industryStatus == 'Current or Past' ? 'All': filterData.industryStatus : CallStage.CURRENT.toString(),
      yearsOfExperienceType: filterData.yearsofexperience ? filterData.yearsofexperience : 'Total'
    };
  }
}
